// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICombineHsaRequestDto
 */
export interface ICombineHsaRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ICombineHsaRequestDto
     */
    account_id_to: number;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaRequestDto
     */
    document_path: string;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaRequestDto
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICombineHsaRequestDto
     */
    send_email_notification_to_employee: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICombineHsaRequestDto
     */
    link_accounts_after_transfer: boolean;
}

/**
 * Check if a given object implements the ICombineHsaRequestDto interface.
 */
export function instanceOfICombineHsaRequestDto(value: object): value is ICombineHsaRequestDto {
    if (!('account_id_to' in value) || value['account_id_to'] === undefined) return false;
    if (!('document_path' in value) || value['document_path'] === undefined) return false;
    if (!('send_email_notification_to_employee' in value) || value['send_email_notification_to_employee'] === undefined) return false;
    if (!('link_accounts_after_transfer' in value) || value['link_accounts_after_transfer'] === undefined) return false;
    return true;
}

export function ICombineHsaRequestDtoFromJSON(json: any): ICombineHsaRequestDto {
    return ICombineHsaRequestDtoFromJSONTyped(json, false);
}

export function ICombineHsaRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICombineHsaRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id_to': json['account_id_to'],
        'document_path': json['document_path'],
        'note': json['note'] == null ? undefined : json['note'],
        'send_email_notification_to_employee': json['send_email_notification_to_employee'],
        'link_accounts_after_transfer': json['link_accounts_after_transfer'],
    };
}

export function ICombineHsaRequestDtoToJSON(json: any): ICombineHsaRequestDto {
    return ICombineHsaRequestDtoToJSONTyped(json, false);
}

export function ICombineHsaRequestDtoToJSONTyped(value?: ICombineHsaRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id_to': value['account_id_to'],
        'document_path': value['document_path'],
        'note': value['note'],
        'send_email_notification_to_employee': value['send_email_notification_to_employee'],
        'link_accounts_after_transfer': value['link_accounts_after_transfer'],
    };
}

